// src/sections/Impact.jsx

import { motion } from "framer-motion";
import { impactData } from "../data/siteContent";
import {
  fadeUp,
  slideLeft,
  slideRight,
  staggerParent,
  viewportOnce,
} from "../utils/motion";

export default function Impact() {
  return (
    <section
      className="section-block section-block--dark impact-section"
      id="impact"
    >
      <div className="impact-bg-glow impact-bg-glow--one" />
      <div className="impact-bg-glow impact-bg-glow--two" />

      <div className="container-shell">
        <motion.div
          className="impact-stage"
          variants={staggerParent}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          <motion.div className="impact-stage__intro" variants={slideLeft}>
            <div className="section-eyebrow">{impactData.eyebrow}</div>
            <h2>{impactData.title}</h2>
            <p>{impactData.description}</p>
          </motion.div>

          <motion.div className="impact-stage__board" variants={slideRight}>
            <div className="impact-stage__board-top">
              {impactData.headline.map((item, index) => (
                <motion.article
                  key={item.label}
                  className={`impact-hero-card impact-hero-card--${index + 1}`}
                  variants={fadeUp}
                >
                  <span>{item.label}</span>
                  <strong>{item.value}</strong>
                  <div className="impact-hero-card__orb" />
                </motion.article>
              ))}
            </div>

            <div className="impact-stage__board-bottom">
              {impactData.supporting.map((item) => (
                <motion.article
                  key={item.label}
                  className="impact-support-card"
                  variants={fadeUp}
                >
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </motion.article>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
